"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WITH_SELFIE = exports.WITHOUT_SELFIE = exports.USER_ACTION_DIAGNOSIS_STARTED = exports.USER_ACTION_DIAGNOSIS_COMPLETED = exports.TRACKING_TITLE_SELFIE = exports.TRACKING_TITLE_CONDITIONS = exports.TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = exports.STATE_RESTORED = exports.STATE_LOADING = exports.STATE_DEFAULT = void 0;
const STATE_DEFAULT = exports.STATE_DEFAULT = 'state:default';
const STATE_LOADING = exports.STATE_LOADING = 'state:loading';
const STATE_RESTORED = exports.STATE_RESTORED = 'state:restored';
const TRACKING_TITLE_CONDITIONS = exports.TRACKING_TITLE_CONDITIONS = 'Conditions';
const TRACKING_TITLE_SELFIE = exports.TRACKING_TITLE_SELFIE = 'Selfie';
const TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = exports.TRACKING_CATEGORY_PRODUCT_RECOMMENDATION = 'Product Recommendation';
const USER_ACTION_DIAGNOSIS_STARTED = exports.USER_ACTION_DIAGNOSIS_STARTED = ['skin_advisor', 'Skin diagnosis started'];
const USER_ACTION_DIAGNOSIS_COMPLETED = exports.USER_ACTION_DIAGNOSIS_COMPLETED = ['skin_advisor', 'Skin diagnosis completed'];
const WITH_SELFIE = exports.WITH_SELFIE = 'With selfie';
const WITHOUT_SELFIE = exports.WITHOUT_SELFIE = 'Without selfie';